<template>
  <div id="curveDetailTem">
    <el-form ref="dataForm" :inline="true" :model="formObj" label-width="160px" class="demo-form-inline">
      <el-form-item label="机型">
        <el-input v-model="formObj.modelCode" :disabled="true" />
      </el-form-item>
      <el-form-item label="电池类型">
        <el-input v-model="formObj.batteryTypeZ" :disabled="true" />
      </el-form-item>
      <el-form-item label="工作模式">
        <el-input v-model="formObj.workModeZ" :disabled="true" />
      </el-form-item>
      <el-form-item label="电池容量(Ah)">
        <el-input v-model="formObj.capacity" :disabled="true" />
      </el-form-item>
      <el-form-item label="电池代号">
        <el-input v-model="formObj.batteryModel" :disabled="true" />
      </el-form-item>
      <el-form-item label="电池系统电压(V)">
        <el-input v-model="formObj.batteryVoltage" :disabled="true" />
      </el-form-item>
      <el-form-item label="线压降">
        <el-input v-model="formObj.pressureDrop" :disabled="true" />
      </el-form-item>
      <el-form-item label="充放比">
        <el-input v-model="formObj.chargeDischargeRatio" :disabled="true" />
      </el-form-item>
      <el-form-item label="补偿率">
        <el-input v-model="formObj.compensationRate" :disabled="true" />
      </el-form-item>
      <el-form-item label="总参数组数">
        <el-input v-model="formObj.totalParameterNum" :disabled="true" />
      </el-form-item>
      <el-form-item label="电池工作最高温度(℃)">
        <el-input v-model="formObj.maxBatteryTemperature" :disabled="true" />
      </el-form-item>
      <el-form-item label="电池高温恢复温度(℃)">
        <el-input v-model="formObj.recoveryBatteryTemperature" :disabled="true" />
      </el-form-item>
      <el-form-item label="非浮充温补范围<25">
        <el-input v-model="formObj.warmTonic1" :disabled="true" />
      </el-form-item>
      <el-form-item label="非浮充温补范围>25">
        <el-input v-model="formObj.warmTonic2" :disabled="true" />
      </el-form-item>
      <el-form-item label="EQ电压(V)">
        <el-input v-model="formObj.eqVoltage" :disabled="true" />
      </el-form-item>
      <el-form-item label="EQ电流(A)">
        <el-input v-model="formObj.eqCurrent" :disabled="true" />
      </el-form-item>
      <el-form-item label="EQ时间(小时)">
        <el-input v-model="formObj.eqTime" :disabled="true" />
      </el-form-item>
      <el-form-item label="浮充温补范围<25">
        <el-input v-model="formObj.floatingWarmTonic1" :disabled="true" />
      </el-form-item>
      <el-form-item label="浮充温补范围>25">
        <el-input v-model="formObj.floatingWarmTonic2" :disabled="true" />
      </el-form-item>
      <el-form-item label="零电流跳转参数地址">
        <el-input v-model="formObj.parameterAddress" :disabled="true" />
      </el-form-item>
      <el-form-item label="控制字标志">
        <el-checkbox-group v-model="controlWordSelect">
          <el-checkbox v-for="(item,index) in controlWordOptions" :key="index" :disabled="true" :label="item.value">{{ item.label }}</el-checkbox>
        </el-checkbox-group>
        <!-- <el-input v-model="formObj.controlWordDc" :disabled="true" /> -->
      </el-form-item>
      <!-- <el-form-item label="电池负温值">
        <el-input v-model="formObj.aaaa" :disabled="true" />
      </el-form-item> -->
    </el-form>
    <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}" border>
      <el-table-column prop="name" label="阶段项目" align="center" />
      <!-- 组功能位标志:字符串展示 -->
      <!-- <el-table-column v-if="isShowObj.value0" prop="value0" label="阶段1项目参数" align="center" />
      <el-table-column v-if="isShowObj.value1" prop="value1" label="阶段2项目参数" align="center" />
      <el-table-column v-if="isShowObj.value2" prop="value2" label="阶段3项目参数" align="center" />
      <el-table-column v-if="isShowObj.value3" prop="value3" label="阶段4项目参数" align="center" />
      <el-table-column v-if="isShowObj.value4" prop="value4" label="阶段5项目参数" align="center" />
      <el-table-column v-if="isShowObj.value5" prop="value5" label="阶段6项目参数" align="center" /> -->
      <!-- 组功能位标志:换行展示 -->
      <el-table-column v-if="isShowObj.value0" label="阶段1项目参数" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.key=='functionMarkDc'&&scope.row.value0" style="text-align: center;">
            <p v-for="(i,index) in scope.row.value0" :key="index">{{ i }}</p>
          </div>
          <div v-else>{{ scope.row.value0 }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="isShowObj.value1" label="阶段2项目参数" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.key=='functionMarkDc'&&scope.row.value1" style="text-align: center;">
            <p v-for="(i,index) in scope.row.value1" :key="index">{{ i }}</p>
          </div>
          <div v-else>{{ scope.row.value1 }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="isShowObj.value2" label="阶段3项目参数" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.key=='functionMarkDc'&&scope.row.value3" style="text-align: center;">
            <p v-for="(i,index) in scope.row.value2" :key="index">{{ i }}</p>
          </div>
          <div v-else>{{ scope.row.value2 }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="isShowObj.value3" label="阶段4项目参数" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.key=='functionMarkDc'&&scope.row.value3" style="text-align: center;">
            <p v-for="(i,index) in scope.row.value3" :key="index">{{ i }}</p>
          </div>
          <div v-else>{{ scope.row.value3 }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="isShowObj.value4" label="阶段5项目参数" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.key=='functionMarkDc'&&scope.row.value4" style="text-align: center;">
            <p v-for="(i,index) in scope.row.value4" :key="index">{{ i }}</p>
          </div>
          <div v-else>{{ scope.row.value4 }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="isShowObj.value5" label="阶段6项目参数" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.key=='functionMarkDc'&&scope.row.value5" style="text-align: center;">
            <p v-for="(i,index) in scope.row.value5" :key="index">{{ i }}</p>
          </div>
          <div v-else>{{ scope.row.value5 }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  props: {
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formObj: {
        workModeZ: ''
      },
      controlWordSelect: [],
      tableData: [],
      isShowObj: {
        value0: false,
        value1: false,
        value2: false,
        value3: false,
        value4: false,
        value5: false
      },
      controlWordOptions: [
        { label: '浮充补偿运算法则', value: 0 },
        { label: '强制触发功能', value: 1 },
        { label: '电池负温使能位', value: 2 },
        { label: 'bit3', value: 3 },
        { label: 'bit4', value: 4 },
        { label: 'bit5', value: 5 },
        { label: 'bit6', value: 6 },
        { label: 'bit7', value: 7 }
      ]
    }
  },
  mounted() {
    this.formObj = JSON.parse(JSON.stringify(this.formData))
    this.queryList()
  },
  methods: {
    queryList() {
      console.log(this.formObj)
      if (this.formObj.batteryType) {
        switch (this.formObj.batteryType) {
          case 1:this.formObj.batteryTypeZ = 'Flooded'; break
          case 2:this.formObj.batteryTypeZ = 'AGM'; break
          case 3:this.formObj.batteryTypeZ = 'GEL'; break
          case 4:this.formObj.batteryTypeZ = 'Lithium'; break
        }
      }
      if (this.formObj.workMode || this.formObj.workMode == 0) {
        switch (this.formObj.workMode) {
          case 0:this.formObj.workModeZ = 'Idel'; break
          case 1:this.formObj.workModeZ = 'Trojan电池模式'; break
          case 2:this.formObj.workModeZ = '骆驼电池'; break
          case 3:this.formObj.workModeZ = '共用曲线'; break
          case 4:this.formObj.workModeZ = '超威电池模式'; break
        }
      }
      if (this.formObj.batteryVoltage) this.formObj.batteryVoltage = (this.formObj.batteryVoltage / 100).toFixed(2)
      if (this.formObj.eqCurrent) this.formObj.eqCurrent = (this.formObj.eqCurrent / 100).toFixed(2)
      if (this.formObj.eqVoltage) this.formObj.eqVoltage = (this.formObj.eqVoltage / 100).toFixed(2)
      if (this.formObj.pressureDrop) this.formObj.pressureDrop = (this.formObj.pressureDrop / 100).toFixed(2)
      // this.formObj.controlWordDc = '101010101'//假数据
      if (this.formObj.controlWordDc) {
        this.controlWordSelect = []
        var arr = this.formObj.controlWordDc.split('')
        arr.forEach((v, i) => {
          if (v == 1) this.controlWordSelect.push(i)
        })
      }
      console.log(this.controlWordSelect)
      var stageList = this.formObj.stageList
      if (stageList.length > 0) {
        // 表格的项目名称
        this.tableData = [
          { name: '输出电压(V)', key: 'outputVoltage' },
          { name: '输出电流(A)', key: 'outputCurrent' },
          { name: '每节每度温补>25(mV)', key: 'eachWarmTonic1' },
          { name: '每节每度温补<25(mV)', key: 'eachWarmTonic2' },
          { name: '回冲电压(V)', key: 'rechargeVoltage' },
          { name: '回冲时间(秒)', key: 'rechargeTime' },
          { name: '电池系统判定时间(分钟)', key: 'checkTime' },
          { name: '充电阶段', key: 'chargerStage' },
          { name: '跳转位', key: 'jumpBit' },
          { name: '充电指示', key: 'chargerInstructions' },
          { name: '关闭环路电压值(V)', key: 'closeVoltage' },
          { name: '恢复环路电压值(V)', key: 'recoveryVoltage' },
          { name: '跳转电压(V)', key: 'jumpVoltage' },
          { name: '电压跳转时间(秒)', key: 'jumpVoltageTime' },
          { name: '跳转电流(A)', key: 'jumpCurrent' },
          { name: '电流跳转时间(秒)', key: 'jumpCurrentTime' },
          { name: 'dv/dt幅值(mV)', key: 'dvdtValue' },
          { name: 'dv/dt时间(分钟)', key: 'dvdtTime' },
          { name: '工作时长(小时)', key: 'workTime' },
          { name: '组功能位标志', key: 'functionMarkDc' }
        ]
      }
      // stageList长度不一致，先全部隐藏，再显示
      for (var attr in this.isShowObj) this.isShowObj[attr] = false
      stageList.forEach((v, i) => {
        this.isShowObj['value' + i] = true
        for (var attr in v) {
          this.tableData.forEach(taV => {
            if (attr == taV.key) {
              var val = 'value' + i
              switch (attr) {
                case 'outputVoltage' :taV[val] = (stageList[i][attr] / 100).toFixed(2); break
                case 'outputCurrent':taV[val] = (stageList[i][attr] / 100).toFixed(2); break
                case 'eachWarmTonic1':taV[val] = Math.round(stageList[i][attr] / 10); break
                case 'eachWarmTonic2':taV[val] = Math.round(stageList[i][attr] / 10); break
                case 'rechargeVoltage':taV[val] = (stageList[i][attr] / 100).toFixed(2); break
                case 'chargerStage': {
                  switch (stageList[i][attr]) {
                    case 0:taV[val] = 'Idle'; break
                    case 1:taV[val] = 'Repair'; break
                    case 2:taV[val] = 'Bulk1'; break
                    case 3:taV[val] = 'Bulk2'; break
                    case 4:taV[val] = 'Absorption'; break
                    case 5:taV[val] = 'Finish'; break
                    case 6:taV[val] = 'Float'; break
                  }
                  break
                }
                case 'jumpBit': {
                  switch (stageList[i][attr]) {
                    case 0:taV[val] = 'Idle'; break
                    case 1:taV[val] = '结束跳转，关闭输出'; break
                    case 2:taV[val] = '重复流程'; break
                    case 3:taV[val] = '依据工作模式进行跳转'; break
                    case 4:taV[val] = '维持当前阶段'; break
                  }
                  break
                }
                case 'chargerInstructions': {
                  switch (stageList[i][attr]) {
                    case 1:taV[val] = '关闭'; break
                    case 2:taV[val] = '闪50%'; break
                    case 3:taV[val] = '闪70%'; break
                    case 4:taV[val] = '闪100%'; break
                    case 5:taV[val] = '全常亮'; break
                  }
                  break
                }
                case 'jumpVoltage':taV[val] = (stageList[i][attr] / 100).toFixed(2); break
                case 'jumpCurrent':taV[val] = (stageList[i][attr] / 100).toFixed(2); break
                case 'functionMarkDc': {
                  if (stageList[i][attr]) {
                    // 组功能位标志:字符串展示
                    // taV[val] = ''
                    // if (stageList[i][attr][0] == 1)taV[val] += '零电流检测功能位; '
                    // if (stageList[i][attr][1] == 1)taV[val] += '启动容量补偿计算; '
                    // if (stageList[i][attr][2] == 1)taV[val] += 'EQ使能位; '
                    // if (stageList[i][attr][3] == 1)taV[val] += '启动容量退出; '
                    // if (stageList[i][attr][4] == 1)taV[val] += '微调工作时长;'

                    // 组功能位标志:换行展示
                    var arr = []
                    if (stageList[i][attr][0] == 1)arr.push('零电流检测功能位')
                    if (stageList[i][attr][1] == 1)arr.push('启动容量补偿计算')
                    if (stageList[i][attr][2] == 1)arr.push('EQ使能位')
                    if (stageList[i][attr][3] == 1)arr.push('启动容量退出')
                    if (stageList[i][attr][4] == 1)arr.push('微调工作时长')
                    taV[val] = arr
                  }
                  break
                }
                default:taV[val] = stageList[i][attr]
              }
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
</style>
